/**
 * Checks if a storage unit is still pending creation.
 * Units have a temporary ID (tempId-*) until the backend returns the real ID.
 */
export const isPendingCreation = (id: string): boolean => {
  return id.startsWith('tempId-');
};
